"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _form = require("../../form");

var _DropdownContext = require("../../form/select/dropdown/DropdownContext");

var _layout = require("../../layout");

var _screenReaderOnly = require("../../screen-reader-only");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DropdownCustomLi = function DropdownCustomLi(_ref) {
  var getItemProps = _ref.getItemProps,
      isHighlighted = _ref.isHighlighted,
      _ref$item = _ref.item,
      checked = _ref$item.checked,
      label = _ref$item.label,
      onClick = _ref$item.onClick,
      index = _ref.index;

  var _useContext = (0, _react.useContext)(_DropdownContext.DropdownContext),
      selectedOptionAltText = _useContext.selectedOptionAltText;

  return (0, _core.jsx)(_helperComponents.StyledDropdownLi, (0, _extends2.default)({
    "aria-describedby": "group-selection-label",
    isHighlighted: isHighlighted,
    withCustomSelectionOptions: true
  }, !!getItemProps ? getItemProps({
    item: label,
    index: index
  }) : {}, {
    onClick: onClick
  }), (0, _core.jsx)(_layout.Row, {
    alignItems: "center",
    gridGap: "S200"
  }, (0, _core.jsx)(_form.Checkbox, {
    checked: checked,
    id: label,
    onChange: function onChange() {
      return null;
    },
    value: label
  }), checked && (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, null, selectedOptionAltText, ", "), label));
};

DropdownCustomLi.displayName = 'DropdownCustomLi';

var _default = /*#__PURE__*/(0, _react.memo)(DropdownCustomLi);

exports.default = _default;